import { BaseModel } from '../../entities/base.model';

export class ColumnModel extends BaseModel {
    key: string;
    label: string;
    type: string;
    sortable: boolean = true;
    filtrable: boolean = true;
}